import { DragOverlay } from "@dnd-kit/core";
import type { ReactNode } from "react";

interface BoardDragOverlayProps {
  children: ReactNode;
}

export function BoardDragOverlay({ children }: BoardDragOverlayProps) {
  return (
    <DragOverlay
      dropAnimation={{
        duration: 200,
        easing: "ease",
      }}
    >
      {children ? (
        <div
          style={{
            transform: "scale(1.03)",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.3)",
            borderRadius: "12px",
            cursor: "grabbing",
          }}
        >
          {children}
        </div>
      ) : null}
    </DragOverlay>
  );
}
